import React from 'react'

import { StyledOverlay } from './styled'

import { Text } from '../Text'

type PostOverlayProps = {
  icon: React.ReactNode
  text: string
  zIndex: number
}

export const PostOverlay = ({ icon, text, zIndex }: PostOverlayProps) => (
  <StyledOverlay align='center' justifyContent='center' zIndex={zIndex}>
    {icon}
    <Text align='center' color='white' fontWeight='bold' fontSize='sm'>
      {text}
    </Text>
  </StyledOverlay>
)
